export default async function(context) {
    const mainAppProps = {
      getMainAppContext: () => {
        return context;
      },
      getEnv: () => {
        let x = Object.assign({}, process.env);
        return x;
      }
    } 
    return mainAppProps;
  }
